import api from "@/api/api-client.ts";
import { isLocalDevelopment } from "@/utils/helpers";
import { useQuery } from "@tanstack/react-query";

const LOCAL_DEV_IP = import.meta.env.VITE_LOCAL_DEV_IP;

export const getClientIp = async () => {
  if (isLocalDevelopment()) {
    return Promise.resolve({ ip: LOCAL_DEV_IP });
  }

  const res = await api.get("/ipify");
  return res.data as { ip: string };
};

export const useClientIp = () => {
  return useQuery({
    queryKey: ["client-ip"],
    queryFn: getClientIp,
  });
};
